<template>
  <div>
    <p class="title_sp">
      <custom-breadcrumb :suffix="userInfo.storeName"/>
    </p>
    <el-card shadow="never" class="profile-card">
      <div class="customer-profile">
        <div class="avatar">
          <el-avatar :size="72" class="customer-avatar">{{userInfo.avatarName}}</el-avatar>
        </div>
        <div class="customer-info">
          <el-row :gutter="167" class="name-row">
            <el-col :span="11" class="profile-col">
              <span class="title" style="display: flex">
                {{ userInfo.storeName }}
                  <div class="openReport" v-if="userInfo['googleStoreId'] && userInfo['googleStoreId']!=='null' " @click="customer(userInfo)">Open Report</div>
              </span>
            </el-col>
            <el-col :span="11" class="profile-col">
              <span>Store types</span><span class="profile-value">{{ userInfo.storeType }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="167">
            <el-col :span="11" class="profile-col">
              <span>Contact person</span><span class="profile-value">{{ userInfo.contactName }}</span>
            </el-col>
            <el-col :span="11" class="profile-col">
              <span>Email</span>
              <span class="profile-value"> <el-button type="info" class="email-btn"><i class="el-icon-chat-round"></i>Send
                  Message</el-button>{{ userInfo.email }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="167">
            <el-col :span="11" class="profile-col">
              <span>Total Sales</span><span class="profile-value">{{ userInfo.totalSales }}</span>
            </el-col>
            <el-col :span="11" class="profile-col">
              <span>Phone</span><span class="profile-value">{{ userInfo.phone }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="167">
            <el-col :span="11" class="profile-col">
              <span>Last transaction date</span><span class="profile-value">{{ userInfo.lastOrderTime }}</span>
            </el-col>
            <el-col :span="11" class="profile-col">
              <span>Repurchase</span><span class="profile-value">{{ userInfo.repurchase }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="167">
            <el-col :span="11" class="profile-col cust-profile-col" :style="{paddingRight:isGoogleMap?'40px !important':'0'}">
              <span>Location</span>
              <span class="profile-value-location" >
                <span>{{ userInfo.location }}</span>
                <img v-if="isGoogleMap" @click="openDialog(localStoreImgList.length-1)" src='../../assets/img/gmap-icon.png' class="gmap-img"/>
              </span>

            </el-col>
            <el-col :span="11" class="profile-col">
              <span>ViLocal Order</span><span class="profile-value">{{ userInfo.vilocalCount }}</span>
            </el-col>
          </el-row>

          <el-row :gutter="167">
            <el-col :span="11" class="profile-col">
              <span>Most Recent Login</span><span class="profile-value">{{ userInfo.lastLoginTime }}</span>
            </el-col>
          </el-row>

        </div>
      </div>
    </el-card>

    <div v-if="this.localStoreImgList.length > 0" class="store-photo-container">
      <div class="title">Store photos</div>
      <!-- style=" position:relative;  margin: 0;" -->
      <div class="swiper-container" >
        <div class="swiper-prev retailers-swiper-prev el-icon-arrow-left" slot="button-prev"></div>
        <swiper style="margin: 20px 0; " :style="{width:`${width}`}" class="swiper pcSwiper2" ref="swiper2" :options="localStoreSwiperOption">
          <swiper-slide v-for="(item, key) in localStoreImgList" :key="key">
            <div class="card-detail">
              <div class="card-img"><img :src="item" @click="openDialog(key)"></div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-next retailers-swiper-next el-icon-arrow-right" slot="button-next"></div>
      </div>
      <el-dialog :visible.sync="visible" width="800px" height="600px" class="dialog-container">
        <template #header>
    <button class="custom-close-button" @click="visible = false">
      <i class="el-icon-close"></i>
    </button>
  </template>
  <!-- <div > -->
    <swiper :options="dialogSwiperOptions" ref="dialogSwiper">
      <swiper-slide v-for="(item, key) in localStoreImgList" :key="key">
        <div class="dialog-content"><img :src="item" class="dialog-slider-image" /></div>
      </swiper-slide>
    </swiper>
  <!-- </div> -->
  <div class="dialog-navigation">
    <div class="dialog-button-prev el-icon-arrow-left" slot="button-prev"></div>
    <div class="dialog-button-next el-icon-arrow-right" slot="button-next"></div>
    <!-- <div class="dialog-close el-icon-close" @click="visible = false"></div> -->
  </div>
</el-dialog>

      <!-- <el-dialog :visible.sync="visible">
        <div class="swiper-container" style=" position:relative;  margin: 0;">
          <div class="dialog-button-next el-icon-arrow-left" slot="button-prev"></div>
          <swiper :options="dialogSwiperOptions" ref="dialogSwiper">
            <swiper-slide v-for="(item, key) in localStoreList" :key="key">
              <img :src="item.img" class="dialog-slider-image" />
            </swiper-slide>
          </swiper>
          <div class="dialog-button-next el-icon-arrow-right" slot="button-next"></div>
        </div>

      </el-dialog> -->
    </div>
    <el-card shadow="never" class="orders-samples-card">
      <div class="title-row">
        <span class="title">Orders</span>
        <span class="view-btn" v-if="!isSelfUser" @click="viewOrdersList(userInfo.userId)">View All</span>
      </div>
      <el-table class="customer-table" :data="orderTable" style="width: 100%" :show-empty="false" empty-text="No data found">
        <el-table-column prop="createTime" label="Create time">
        </el-table-column>
        <el-table-column prop="orderId" label="Order ID">
        </el-table-column>
        <el-table-column prop="orderStatus" label="State">
          <template slot-scope="scope">
            <span>{{  scope.row.orderStatus | statusDis }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="Amount">
          <template slot-scope="scope">
            <span>{{  Number(scope.row.totalPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shipmentDate" label="Shipment date">
        </el-table-column>
        <el-table-column >
          <template slot-scope="scope" v-if="!isSelfUser">
            <div @click="viewOrdersDetail(scope.row.orderId)">
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card shadow="never" class="orders-samples-card">
      <div class="title-row">
        <span class="title">ViLocal Order</span>
        <span class="view-btn"  v-if="!isSelfUser" @click="viewVilocalOrderList(userInfo.userId)">View All</span>
      </div>
      <el-table class="customer-table" :data="vilocalOrderTable" style="width: 100%" :show-empty="false" empty-text="No data found">
        <el-table-column prop="createTime" label="Create time">
        </el-table-column>
        <el-table-column prop="orderId" label="Order ID">
        </el-table-column>
        <el-table-column prop="orderStatus" label="State">
          <template slot-scope="scope">
            <span>{{  scope.row.orderStatus | statusDis }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="Amount">
          <template slot-scope="scope">
            <span>{{  Number(scope.row.totalPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shipmentDate" label="Shipment date">
        </el-table-column>
        <el-table-column >
          <template slot-scope="scope" v-if="!isSelfUser">
            <div @click="viewOrdersDetail(scope.row.orderId)">
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card shadow="never" class="cart-card">
      <div class="title-row">
        <span class="title">Item in Cart</span>
      </div>
      <el-table class="customer-table" :data="itemCartTable" style="width: 100%" max-height="350" empty-text="No data found">
        <el-table-column prop="createTime" label="Create time">
        </el-table-column>
        <el-table-column prop="goodsTitle" label="Product name">
        </el-table-column>
        <el-table-column prop="vdSkuCode" label="VD SKU">
        </el-table-column>
        <el-table-column prop="quantity" label="Quantity">
        </el-table-column>
        <el-table-column prop="costPrice" label="Total Amount">
          <template slot-scope="scope">
            <span>{{  Number(scope.row.totalPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <div class="table-place-holder"></div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>

import {getAction} from '../../api/manage'
import awesomeSwiper from '../home/components/awesomeSwiper.vue'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import qs from 'qs'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import {orderStatusDis} from '../../utils/status'

export default {
  name: 'customersDetail',
  components: { awesomeSwiper, swiperSlide, swiper, CustomBreadcrumb },
  data() {
    return {
      isSelfUser: false,
      storeTypeOptions: [],
      storeTypeMap: {
        '0': 'Brick & Mortar Store',
        '1': 'Brick & Mortar and Online Store',
        '2': 'Online Botique Store',
        '3': 'Pop-up Store',
        '4': 'Social Media'
      },
      visible: false,
      userInfo: {
        storeName: 'N/A',
        storeType: 'N/A',
        contactName: 'N/A',
        email: 'N/A',
        totalSales: 'N/A',
        samples: 'N/A',
        lastOrderTime: 'N/A',
        repurchase: 'N/A',
        phone: 'N/A',
        location: 'N/A',
        lastLoginTime: 'N/A',
        googleStoreId: ''
      },
      searchData: {
        currentPage: 1,
        pageSize: 5,
        userId: this.$route.query.userId
      },
      isGoogleMap: '',
      localStoreImgList: [],
      orderTable: [],
      vilocalOrderTable: [],
      itemCartTable: [],
      tableData: [{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 }],
      width: '100%',
      localStoreSwiperOption: {
        slidesPerView: 5,
        spaceBetween: 20,
        pagination: {
          clickable: true
        },

        navigation: {
          nextEl: '.retailers-swiper-next',
          prevEl: '.retailers-swiper-prev'
        }
      },
      dialogSwiperOptions: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.dialog-button-next',
          prevEl: '.dialog-button-prev'
        }
      }

    }
  },
  created() {
    // this.getStoreType()
    this.initCustomerDetail()
    console.log(this.$data)
  },
  mounted() {
    let that = this
    setTimeout(function () {
      that.getStorePic()
    }, 300)
  },
  filters: {
    statusDis: (value) => {
      return orderStatusDis(value)
    }
  },
  methods: {
    // getStoreType() {
    //   getAction('/v0.2/store_type').then(res => {
    //     if (res.success) {
    //       this.storeTypeOptions = res.result
    //       for (let option of this.storeTypeOptions) {
    //         this.storeTypeMap[option.id] = option.storeTypeName
    //       }
    //     }
    //   })
    // },
    customer(location) {
      var encrypt = btoa(location['googleStoreId'])
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${location.userId}&storeId=${encrypt}&storeName=${location['storeName']}&storeAddress=${location['storeAddress']}`)
      window.open(routeUrl.href, '_blank')
    },
    viewVilocalOrderList(userId) {
      this.$router.push({path: '/menu/Order', query: {orderType: 7}})
    },
    viewOrdersList(userId) {
      this.$router.push({path: '/menu/Order'})
    },
    viewOrdersDetail(orderId) {
      this.$router.push({path: '/menu/OrderDetail', query: {orderId: orderId}})
    },
    openDialog(index) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dialogSwiper.swiper.slideTo(index, 0)
      })
    },
    getCustomerInfo() {
      let id = this.$route.query.userId
      getAction('/v0.2/home/customer/' + id + '/dashboard').then(res => {
        if (res.code === 200 && res.result) {
          this.userInfo = res.result
          this.userInfo.contactName = this.userInfo.storeContactName?this.userInfo.storeContactName:( this.userInfo.firstName + ' ' + this.userInfo.lastName)
          this.userInfo.totalSales = this.userInfo.totalSales ? Number(this.userInfo.totalSales).toLocaleString('en-US', {style: 'currency', currency: 'USD'}) : 'N/A'

          this.userInfo.location = this.userInfo.storeAddress + ', ' + this.userInfo.city + ', ' + this.userInfo.state + ',' + this.userInfo.countryCode + ',' + this.userInfo.zipCode
          this.userInfo.avatarName = this.userInfo.storeName.trim().slice(0, 3)
          this.userInfo.repurchase = this.userInfo.repurchase ? this.userInfo.repurchase : 'N/A'
          this.userInfo.phone = this.userInfo.phone ? this.userInfo.phone : 'N/A'
          this.userInfo.samples = this.userInfo.samples ? this.userInfo.samples : 'N/A'
          this.userInfo.lastOrderTime = this.userInfo.lastOrderTime ? this.userInfo.lastOrderTime : 'N/A'
          this.userInfo.storeType = this.storeTypeMap[this.userInfo.storeType]
        } else {
          console.error(res)
        }
      })
    },

    getStorePic() {
      getAction('/vilocal/shop/order/api/v0.2/config/' + this.$route.query.userId).then(res => {
        if (res.success) {
          if (res.result) {
            if (res.result.imgList && res.result.imgList.length > 0) {
              this.localStoreImgList = res.result.imgList
              let imgListLen = this.localStoreImgList.length
              if (imgListLen < 5) {
                this.localStoreSwiperOption['slidesPerView'] = imgListLen
                this.width = (imgListLen * 220) + 'px'
              }
              if (res.result.googleImg) {
                this.isGoogleMap = res.result.googleImg
              }
            }
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    getCustomerOrders() {
      let searchQuery = this.searchData
      // console.log(searchQuery)
      getAction(`/v0.2/home/orders?${qs.stringify(searchQuery)}`).then(res => {
        if (res.code === 200) {
          this.orderTable = res.result.records
        }
      })
    },

    getCustomerVilocal() {
      let searchQuery = this.searchData
      searchQuery.orderType = 7
      getAction(`/v0.2/home/orders?${qs.stringify(searchQuery)}`).then(res => {
        if (res.code === 200) {
          // console.log(res)
          this.vilocalOrderTable = res.result.records
        }
      })
    },

    getCustomerItemInCart() {
      let id = this.$route.query.userId
      // 该表最多展示20行

      getAction(`/v0.2/home/cartItems/${id}?pageSize=20&currectPage=1`).then(res => {
        if (res.code === 200) {
          this.itemCartTable = res.result.records
        }
      })
    },

    initCustomerDetail() {
      this.getCustomerInfo()
      this.getCustomerOrders()
      this.getCustomerVilocal()
      this.getCustomerItemInCart()
      // let roleInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
      // this.isSelfUser = roleInfo.value.userSource === 2 && roleInfo.value.supplierManagementModel === 2
    }
  }
}
</script>

<style scoped lang="less">
.card-img{
  width: 208px !important;
  cursor: pointer;
}
.el-card {
  margin-bottom: 20px;
}

.profile-card {
  height: 232px;
}

.customer-profile {
  display: flex;
  flex-direction: row;
}

.swiper-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start
}

.swiper-slide{
  width:20%;
}

.swiper-slide img {
  width: 100%; /* 设置图片宽度为 100% */
  object-fit: cover; /* 根据需要调整图片的填充方式 */
}

.customer-info {
  margin-left: 20px;
  width: 100%;
}

.title {
  font-size: 16px;
  margin-bottom: -2px;
}

.profile-col {
  position: relative;
  margin-top: 15px;
}
.cust-profile-col{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.swiper-prev {
  width: 20px !important;
  height: 58px;

  display: flex;
  align-items: center;
  font-size: 25px;
}

.swiper-next {
  width: 20px !important;
  height: 58px;
  display: flex;
  align-items: center;
  font-size: 25px;
}

.swiper-prev.swiper-button-disabled,
.swiper-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.profile-value {
  position: absolute;
  right: 0;
}

.profile-value-location {
  text-align: right;
  width: 80%;

  > span {
    width: 98%;
    display: inline-block;
    min-height: 20px;
  }

  img {
    position: absolute;
    right: -5px;
    top: -5px;
  }
}

.email-btn {
  height: 20px;
  width: 137px;
  padding: 0 !important;
  margin-right: 5px;
}

.title-row {
  position: relative;
}

.view-btn {
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.expand-class {
  width: 100%
}

.swiper-prev {}

/deep/ .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: none !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
  z-index: 0;
}
.dialog-container {
  padding: 0;
}

.dialog-content {
  height:600px;
  width:800px;
  img{
    width: 100%;
    height: 100%;
    object-fit:contain
  }
}

.dialog-navigation {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  z-index: 1;
}

.dialog-button-prev,
.dialog-button-next,
.dialog-close {
  font-size: 30px;
  color: white;
  cursor: pointer;
}

.dialog-button-prev:hover,
.dialog-button-next:hover,
.dialog-close:hover {
  color: #ccc;
}

.dialog-button-prev {
  margin-right: 10px;
}

.dialog-close {
  position: absolute;
  top: 10px;
  right: 10px;
}

.name-row{
  top: 5px;
}

/deep/ .el-dialog__headerbtn {
    position: absolute;
    height: 32px;
    width:32px;
    top: 0;
    right: 0;
    padding: 0;
    background: #262B2F;
    opacity: 0.9;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 30px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
    color: white;
    position: relative;
    bottom: 3px;
}

.gmap-img{
  cursor: pointer;
  position:relative;
  top:10px;
}

.customer-avatar{
  background-color: #F3E93D;
  color: #262B2F;
  font-size: 16px;
}
.title_sp {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 600;
  color: #262B2F;
  margin-bottom: 20px;
}

.openReport{
  margin-left: 10px;
  width: 150px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  background: #262B2F;
  color: #FFFFFF;
  cursor: pointer;
}
.card-detail{
  width: 208px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin:0 auto
}
.card-img{
  // border-radius: 5px !important;
  // width: 100%;
  // cursor:pointer;
  width: 208px;
  height: 156px;
  img{
    border-radius: 5px !important;
    width: 100%;
    height: 100%;
    object-fit:cover;
    cursor:pointer;
  }
}
/deep/ .el-dialog{
  background: black !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/customersDetail.vue